import { render, staticRenderFns } from "./NpsRating.vue?vue&type=template&id=45a7ae15&scoped=true&"
import script from "./NpsRating.vue?vue&type=script&lang=js&"
export * from "./NpsRating.vue?vue&type=script&lang=js&"
import style0 from "./NpsRating.vue?vue&type=style&index=0&id=45a7ae15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7ae15",
  null
  
)

export default component.exports